const route = {
  path: 'medicaid',
  component: () => import('@/views/medicaid/certification/Wrapper.vue'),
  children: [
    {
      path: '/medicaid/certification',
      name: 'medicaid-certification',
      component: () => import('@/views/medicaid/certification/Main.vue'),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['menu.rempro.medicaid.certification.view'],
        },
      },
    },
  ],
};

export default route;
